import Container from "../components/Container";
import Image from "../components/Image";

import logo from "../assets/images/logo-transparent.png";
import logoFull from "../assets/images/logo-full.png";
import LoginForm from "../components/LoginForm";
import { ForgotPasswordProvider } from "../contexts/ForgotPasswordContext";
import { useState } from "react";
import SignUpForm from "../components/SignUpForm";

export default function SignInPage() {
    const [showSignUpForm, setShowSignUpForm] = useState(false);

    return (
        <Container between center fullHeight>
            <Container center fullWidth flexColumn>
                <Image src={logoFull} width={263} height={67} />

                {
                    showSignUpForm
                        ? (
                            <SignUpForm onSignIn={() => setShowSignUpForm(false)} />
                        )
                        : (
                            <ForgotPasswordProvider>
                                <LoginForm onSignUp={() => setShowSignUpForm(true)} />
                            </ForgotPasswordProvider>
                        )
                }
            </Container>

            <Container bgPrimary center fullWidth fullHeight hiddenMobile>
                <Image src={logo} width={325} height={325} />
            </Container>
        </Container>
    );
}
 